import { ScrollAdDispatcher } from "./ScrollAdDispatcher";
import { StripChatAdDispatcher } from "./stripChat/StripChatAdDispatcher";
import { AdUnitsKeys } from "./config/units";

interface IProps {
  position: number;
  fullscreen: boolean;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

export const FeedAds = (props : IProps) => {
  const { position, fullscreen, mobileAds, desktopAds } = props;

  return !fullscreen ? (
    <ScrollAdDispatcher
      key={`ScrollAdDispatcher${position}`}
      position={position + 1}
      mobileAds={mobileAds}
      desktopAds={desktopAds}
    />
  ) : (
    <StripChatAdDispatcher
      key={`StripChat${position}`}
      position={position}
    />
  );
};
